import React, { useRef, useState } from 'react';
import Gallery from './Gallery';
import { galleryData } from '../data/galleryData';

const Apple = () => {
  const galleryRef = useRef();
  const [showMore, setShowMore] = useState(false);

  const handleExploreMore = () => {
    galleryRef.current?.openGallery(0);
  };

  const handleCelebration = () => {
    setShowMore(!showMore);
  };

  return (
    <section id="apple" className="section apple-section">
      <div className="section-header">
        <img src="/images/apple.png" alt="Apple" className="section-icon" />
        <h1>Southington, CT. 06489</h1>
      </div>
      <p>
		<b><a href="https://www.southington.org/" target="_blank" rel="noreferrer">Southington CT</a></b> is situated about 20 miles southwest of Hartford, 80 miles northeast of New York City, 105 miles southwest of Boston and 77 miles west of Providence.
		It includes the areas of Plantsville, Marion and Milldale, each of which has its own post office and distinct architecture.
      </p>
	  
	          {showMore && (
          <div className="extended-intro">
            <p>I LOVE SOUTHINGTON is a song that was written & performed by Kevin Curtiss. I want to give you the lyrics, and maybe some day I will. For now just know that it's sung to the same rhythm and beat as I Love Rock-n-Roll by Joan Jett.</p>
            <p>It inspired me to come up with the I Love Southington logo that features an <i className="fas fa-apple-whole"></i> in the shape of a <i className="fas fa-heart"></i> to act as the "o" in "Love".</p>
          </div>
        )}

      <div className="cta-buttons">
        <button className="cta-btn primary" onClick={handleCelebration}>
          <i className="fas fa-heart"></i>
          {showMore ? 'Less' : 'I Love Southington'}
        </button>

        <button className="cta-btn secondary" onClick={handleExploreMore}>
          <i className="fas fa-map-marked-alt"></i>
          Explore Town
        </button>
      </div>
      
	  <Gallery ref={galleryRef} images={galleryData.apple} sectionName=" " maxDisplay={4} />

    </section>
  );
};

export default Apple;
